import axios from "axios";
import authHeader from "./auth-header";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
const API_URL = process.env.VUE_APP_API_URL;

class ListingService {
  // Fetch all listings
  index() {
    return axios.get(`${API_URL}listings`, { headers: authHeader() });
  }

  // Fetch a specific listing by ID
  show(id) {
    return axios.get(`${API_URL}listings/${id}`, { headers: authHeader() });
  }

  // Fetch listings by subcategory
  subCategoryListings(subcategoryId) {
    return axios.get(`${API_URL}subcategory-listings/${subcategoryId}`, { headers: authHeader() });
  }

  // // Create a new listing
  // async store(resource, subcategoryId, categoryId) {
  //   const endpoint = this.getEndpointBySubcategory(subcategoryId, categoryId);
  
  //   // Log the API URL, endpoint, payload, and headers
  //   console.log("API_URL:", API_URL);
  //   console.log("Resolved endpoint:", endpoint);
  //   console.log("Payload being sent:", resource);
  //   console.log("Headers being sent:", authHeader());
  
  //   try {
  //     const response = await axios
  //       .post(`${API_URL}${endpoint}`, resource, { headers: authHeader() });
  //     console.log("Response received from backend:", response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error received from backend:", error.response || error.message);
  //     throw error;
  //   }
  // }

 
  async store(resource, subcategoryId, categoryId) {
    const endpoint = this.getEndpointBySubcategory(subcategoryId, categoryId);

    // Prepare headers
    let headers = authHeader();
    // If resource is FormData, set multipart header
    if (resource instanceof FormData) {
      headers = { ...headers, "Content-Type": "multipart/form-data" };
    }

    // Logging
    console.log("API_URL:", API_URL);
    console.log("Resolved endpoint:", endpoint);
    // For FormData, log keys and values for debugging
    if (resource instanceof FormData) {
      for (let pair of resource.entries()) {
        console.log(`FormData: ${pair[0]} =`, pair[1]);
      }
    } else {
      console.log("Payload being sent:", resource);
    }
    console.log("Headers being sent:", headers);

    try {
      const response = await axios.post(
        `${API_URL}${endpoint}`,
        resource,
        { headers }
      );
      console.log("Response received from backend:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error received from backend:", error.response || error.message);
      throw error;
    }
  }


  // Update an existing listing
  update(resource, id) {
    return axios.put(`${API_URL}listings/${id}`, resource, { headers: authHeader() });
  }

  // Delete a listing
  delete(id) {
    return axios.delete(`${API_URL}listings/${id}`, { headers: authHeader() });
  }

 // Map subcategoryId to endpoint
 getEndpointBySubcategory(subcategoryId, categoryId) {
  // Define endpoint mapping by subcategoryId
  const endpointMapping = {
    1: "listing-car", // Cars
    2: "listing-motorcycle", // Motorcycles
    3: "listing-autoaccessory", // Auto Accessories & Parts
    4: "listing-heavy-vehicle", // Heavy Vehicles
    5: "listing-boat", // Boats
    6: "listing-number-plate", // Number Plates
    7: "listing-property", // Property for Sale (Residential)
    8: "listing-property", // Property for Sale (Commercial)
    9: "listing-property", // Property for Sale (Land)
    10: "listing-property", // Property for Sale (Multiple Units)
    204: "listing-property", // Property for Sale
    16: "listing-job", // I'm Hiring
    17: "listing-job", // I want a job
    701: "listing-furniture-garden", // Furniture & Garden
    801: "listing-mobile-tablet", // Mobile & Tablets
  };

  // Special case: Map endpoint by categoryId for Community and Classified
  if (categoryId === 5) {
    console.log("Special case: Resolved endpoint for categoryId 5 (Community)");
    return "listing-community"; // Community
  }
  
  // Special case for Property for Rent
  if (categoryId === 4) {
    console.log("Special case: Resolved endpoint for categoryId 4 (Property for Rent)");
    return "listing-property"; // Property for Rent
  }
  
  else if (categoryId === 6) {
    console.log("Special case: Resolved endpoint for categoryId 6 (Classified)");
    return "listing-classified"; // Classified
  }

  // Default case: Map endpoint by subcategoryId
  const endpoint = endpointMapping[subcategoryId];
  console.log("Resolved endpoint for subcategoryId:", subcategoryId, "is:", endpoint);
  if (!endpoint) {
    throw new Error(`No endpoint found for subcategoryId: ${subcategoryId}`);
  }
  return endpoint;
}
}

export default new ListingService();